export const isCompleted = (percent: number) => percent === 100;
